import graphql__f3efe309278488107f82 from "./__generated__/PersonalAppsMenuItemQuery.graphql.ts";
import graphql__ded7f2e92c79d7d12aab from "./__generated__/PersonalAppsMenuItem_viewer.graphql.ts";import graphql from 'babel-plugin-relay/macro'
import { useAppToDatabaseRename } from 'components/hooks'
import paths from 'paths'
import { useEffect } from 'react'
import { useLazyLoadQuery, useRefetchableFragment } from 'react-relay/hooks'
import { useNavigate } from 'react-router-dom'

import { PersonalAppsMenuItem_viewer$key } from './__generated__/PersonalAppsMenuItem_viewer.graphql'
import { PersonalAppsMenuItemQuery } from './__generated__/PersonalAppsMenuItemQuery.graphql'
import { ViewerAppsRefetchQuery } from './__generated__/ViewerAppsRefetchQuery.graphql'
import AppTenantMenuButton from './AppTenantMenuButton'

const query = graphql__f3efe309278488107f82

const refetchableApps = graphql__ded7f2e92c79d7d12aab

type Props = {
  /** True if the menu item is open */
  isOpen: boolean
}

// Menu item for accessing the user's personal apps.
export default function PersonalAppsMenuItem({ isOpen }: Props) {
  const { viewer } = useLazyLoadQuery<PersonalAppsMenuItemQuery>(query, {})
  const [data, refetch] = useRefetchableFragment<
    ViewerAppsRefetchQuery,
    PersonalAppsMenuItem_viewer$key
  >(refetchableApps, viewer)

  useEffect(() => {
    if (isOpen) {
      refetch({}, { fetchPolicy: 'store-and-network' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  const navigate = useNavigate()

  const apps = data?.me?.apps ?? []

  const { databasesText, isRenamed } = useAppToDatabaseRename()

  return (
    <div className="flex flex-col gap-0.5">
      {apps.length > 0 ? (
        apps.map((userApp, index) => {
          const redirectTo = paths.app({
            appSlug: userApp.slug,
            isRenamed,
          })

          return (
            <AppTenantMenuButton
              key={index}
              label={userApp.name}
              onClick={() => navigate(redirectTo)}
            />
          )
        })
      ) : (
        <AppTenantMenuButton
          label={`You do not have any ${databasesText} yet`}
          disabled
        />
      )}
    </div>
  )
}
